import React, { Component, PropTypes } from 'react';
import FacebookProvider, { Comments } from 'react-facebook';

export default class FacebookComments extends Component {
  static propTypes = {
    version: PropTypes.string,
    appId: PropTypes.string.isRequired,
    href: PropTypes.string,
    numPosts: PropTypes.number,
    orderBy: PropTypes.string,
    colorScheme: PropTypes.string,
    width: PropTypes.string
  }

  // NOTE: colorScheme and orderBy defaults inside 'react-facebook' turns into all
  // caps, which causes issues. Not 100% sure, but may have to do with our specific
  // build setup. This is a workaround, which works at least for now.
  static defaultProps = {
    version: 'v2.5',
    numPosts: 5,
    colorScheme: 'light',
    width: '100%',
    orderBy: 'social'
  }

  render() {
    const {
      version,
      appId: appID,
      href,
      colorScheme,
      width,
      numPosts,
      orderBy
    } = this.props;

    const appConfig = {
      version,
      appID
    };

    const commentsProps = {
      colorScheme,
      width,
      numPosts,
      orderBy
    };

    if (href) {
      commentsProps.href = href;
    } else {
      // WEB-4491 for HTTPS, use the hostname + pathname only: https://stackoverflow.com/questions/43620722/can-we-get-the-fb-comments-made-for-the-http-site-now-that-weve-moved-to-https
      commentsProps.href = window.location.hostname + window.location.pathname; // for now this only runs client-side.
    }

    return (
      <div className="FacebookComment">
        <FacebookProvider {...appConfig} >
          <Comments {...commentsProps} />
        </FacebookProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/social/FacebookComments.js